import Footer from "../Sub/Footer";
import webBanner from "../../images/webBanner.png";
import CommonHeader from "../Sub/CommonHeader";
import Banner from "../Sub/Banner";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { addContact } from "../../reducers/commonReducer";
import { useDispatch } from "react-redux";

const schema = yup.object().shape({
  name: yup.string().required(),
  gst: yup.string(),
  email: yup.string().email().required(),
  phone: yup.string().min(10).max(10).required(),
  message: yup.string().required(),
  privacyPolicy: yup
    .boolean()
    .oneOf([true], "You must accept the privacy policy"),
});

const Contact = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <>
      <CommonHeader />
      <div>
        <Banner bannerImg={webBanner} />
      </div>
      <div className="container-fluid">
        <div className="page-main p-5 mbl-pedding-10">
          <div className="section__head d-md-flex justify-content-between mb-40">
            <div className="section__title">
              <h1>
                Contact <span>Us</span>
              </h1>
            </div>
          </div>
          <Row className="align-item-center">
            <Col md={6} className="hideMb">
              <div>
                <h3>
                  <b>Address</b>
                </h3>
                <p>
                  <b>Building No./Flat No.</b>: RAIGARO KA MOHALLA<br/>
                  <b>Road/Street</b>: AJMER ROAD<br/>
                  <b>Locality/Sub Locality</b>: KESHOPURA<br/>
                  <b>City/Town/Village</b>: Jaipur<br/>
                  <b>District</b>: Jaipur<br/>
                  <b>State</b>: Rajasthan<br/>
                  <b>PIN Code</b>: 302021
                  <br /><br />
                  TEL. NO.: 63677-22194
                  <br />
                  Email: dayalenterprises@gmail.com
                </p>
              </div>
            </Col>
            <Col md={6} className="box-shadows mbl-pedding-10 p-5">
              <div className="border-y mb-4">
                <h2 className="mb-0">Get In Touch</h2>
              </div>
              <Formik
                validationSchema={schema}
                onSubmit={async (values, { resetForm }) => {
                  const apiResp = await dispatch(addContact(values));
                  if(apiResp?.payload?.status){
                    resetForm({ values: "" });
                  }
                }}
                initialValues={{
                  name: "",
                  email: "",
                  phone: "",
                  message: "",
                  privacyPolicy: false,
                }}
              >
                {({ handleSubmit, handleChange, touched, values, errors }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            isInvalid={!!errors.name}
                            className={errors.name && touched.name && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                            className={
                              errors.email && touched.email && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Phone"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            isInvalid={!!errors.phone}
                            className={
                              errors.phone && touched.phone && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} sm={12} className="mt-3">
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Message</Form.Label>
                          <Form.Control
                            type="text"
                            as="textarea"
                            placeholder="Enter Message"
                            name="message"
                            value={values.message}
                            onChange={handleChange}
                            isInvalid={!!errors.message}
                            className={
                              errors.message && touched.message && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group controlId="privacyPolicy" className="mb-3">
                          <Form.Check
                            type="checkbox"
                            label={
                                <>
                                  By submitting this form, I agree to the{" "}
                                  <span
                                    onClick={() => navigate("/privacy-policy")}
                                    style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                  >
                                    Privacy Policy
                                  </span> of <br/><b>DAYAL ENTERPRISES</b>.
                                </>
                              }
                            name="privacyPolicy"
                            checked={values.privacyPolicy}
                            onChange={handleChange}
                            isInvalid={
                              !!errors.privacyPolicy && touched.privacyPolicy
                            }
                            feedback={errors.privacyPolicy}
                            feedbackType="invalid"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button
                      variant="success"
                      className="bg-thememain"
                      type="submit"
                    >
                     Submit
                    </Button>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
